import { hexLen, worldToHex } from '../hex.ts';
import { withinRange } from '../math/fixed.ts';
import type { BattleState } from '../types.ts';
import { ev, isFlying } from './combat.ts';

/**
 * One alone (a bet, docs/SAGAS.md): a single hero holds a whole road, as Ser Gaspar did. The whole fight comes down
 * it; Brann's stakes mark its mouth, where it opens on the clearing. A nightmare that walks past them into the
 * clearing has got through; `max` of them lose the bet.
 */

export const aloneTick = (s: BattleState): void => {
  const r = s.rules?.alone;
  if (!r) return;
  const st = (s.alone ??= { crossed: [] });
  if (!s.started) return;
  const inner = s.map.bastion;
  for (const e of s.enemies) {
    if (e.hp <= 0 || isFlying(e) || e.kind === 'boneWall' || !withinRange(e.x, e.y, 0, 0, inner * 1000) || st.crossed.includes(e.id)) continue;
    // Past the mouth (the clearing's edge ring): inside it.
    const h = worldToHex(e.x, e.y);
    if (hexLen(h.q, h.r) >= inner) continue;
    st.crossed.push(e.id);
    ev(s, { t: 'alone', n: st.crossed.length, x: e.x, y: e.y });
  }
};

/** Too many got through: lost (otherwise the hold decides it, like any other). */
export const aloneLost = (s: BattleState): boolean => !!s.rules?.alone && (s.alone?.crossed.length ?? 0) >= s.rules.alone.max;
